import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  goToDifficultRoute: () => void
}

export const ComplexRoute: FC<Props> = ({ goToDifficultRoute }) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div
        className={s.content}
        onClick={goToDifficultRoute}
      >
        <AppIcon
          id={AllIcons.ROUTE}
          className={s.icon}
        />

        <span className="regular-14">{t('create_difficult_route')}</span>
      </div>
    </div>
  )
}
